import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Button, Card, Col, Row } from 'react-bootstrap';
import EstadiasUbicacionesFrecChart from './EstadiasUbicacionesFrecChart';
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
import Flex from '../../../../../components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import IconButton from '../../../../../components/common/IconButton';

const EstadiasUbicacionesFrec = ({ data, onSelectAlertType, highlightedAlertType, handleCleanFilters }) => {
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    let dataFiltered = null;

    if (highlightedAlertType) {
        dataFiltered = data.filter(item => item.title == highlightedAlertType);
    }

    const style = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    return (
        <Card className="h-md-100">
            <FalconCardHeader
                title={highlightedAlertType ? `Estadías por Ubicación: ${highlightedAlertType}` : "Estadías por Ubicación"}
                titleTag="h6"
                light
                endEl={highlightedAlertType && (<IconButton onClick={handleCleanFilters} icon="times-circle" size="sm" variant="falcon-default">Remover filtro</IconButton>)}
            />

            <Card.Body as={Row}>
                <Col md={4} className="mb-xxl-1 align-content-center">
                    <EstadiasUbicacionesFrecChart data={dataFiltered || data} onSelectAlertType={onSelectAlertType} />
                </Col>
                <Col md={8}>
                    <div className="overflow-auto pe-x1" style={{ maxHeight: '250px' }}>
                        {data.map((item, index) => {
                            let isLast = index === data.length - 1;
                            let highlighted = highlightedAlertType === item.title;
                            return (<div>
                                <Row
                                    className={classNames(
                                        'position-relative align-items-center py-2 ps-3 g-0 flex-nowrap',
                                        { 'border-bottom border-200': !isLast },
                                        { 'text-danger fw-bold': highlighted }
                                    )} style={{ minWidth: '350px' }} href="#!" onClick={(e) => {
                                        e.preventDefault();
                                        onSelectAlertType(item.title);
                                    }}
                                >
                                    <Col className="py-1 px-3 ps-x1 overflow-auto" >
                                        <Flex className="justify-content-between" >
                                            <Row className='mx-0 px-0' style={{ width: '40%' }}>
                                                <Flex className={classNames(
                                                    'm-0 p-0 align-items-center text-truncate flex-grow-1 flex-nowrap',
                                                    { 'fw-bold': highlighted }
                                                )} tag="h6" style={{ ...style }}>
                                                    <a className={classNames('label-detail-card px-0 mx-0', {
                                                        'fw-bold': highlighted
                                                    })}
                                                        style={{ fontSize: '14px', ...style, color: highlighted ? item.color : '#212121' }}
                                                        title={item.title}>
                                                        {item.title}
                                                    </a>
                                                </Flex>
                                            </Row>
                                            <Row className="justify-content-end text-end mx-2 g-0 flex-nowrap justify-content-between" style={{ width: '60%', minWidth: '280px' }} >

                                                <div className="justify-content-between d-flex flex-nowrap">

                                                    <div className='mx-2 text-start ' style={{ color: highlighted ? item.color : '#212121' }}>
                                                        {item.hours} hr(s)
                                                    </div>
                                                    <Badge pill bg="200">
                                                        <div className="m-0 fs-10 fw-semibold text-primary">{item.visits} Visitas</div>
                                                    </Badge>
                                                    <a className="ms-2" style={{
                                                        color: highlighted ? item.color : 'inherit', width: '20px'
                                                    }}>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                    </a>
                                                </div>
                                            </Row>
                                        </Flex>
                                    </Col >
                                </Row >
                            </div >);
                        }

                        )}
                    </div>
                </Col>
            </Card.Body>

            {/* <Card.Footer>
                <Row>
                    <Col md={12} className="d-flex justify-content-end mt-3">
                        <Button variant="primary" onClick={handleCleanFilters}>
                            Remover Filtros
                        </Button>
                    </Col>
                </Row>
            </Card.Footer> */}
        </Card>
    );
};

EstadiasUbicacionesFrec.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onSelectAlertType: PropTypes.func.isRequired, // 📌 Nueva función para seleccionar alertas
    highlightedAlertType: PropTypes.string // 📌 Estado de alerta seleccionada
};

export default EstadiasUbicacionesFrec;
